import { inject, Injectable } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

import { CONTENT_TEXT_POSITION } from '@app/core/cms-flex/constants';
import { DpCmsFlexComponentService } from '@app/core/cms-flex/services';

import {
  COLUMN_WIDTH,
  CONTENT_COLOR,
  SUB_TITLE_SIZE,
  TITLE_IMAGE,
  UNDERLINE_TYPE,
  CONTENT_ALIGNMENT,
  IMAGE_CONTENT_FIT,
  SLOT_BOTTOM_OFFSET,
  SLOT_TOP_OFFSET
} from '../constants';
import { ContentCSS, FlexibleContentSectionComponent, FlexibleContentSectionData, SlotCSS, MediaFit } from '../types';

@Injectable()
export class DpFlexibleContentSectionComponentService extends DpCmsFlexComponentService<FlexibleContentSectionData> {
  readonly #domSanitizer = inject(DomSanitizer);

  protected mapComponentData(data: FlexibleContentSectionComponent): FlexibleContentSectionData {
    return {
      slotCSS: this.#buildSlotCSS(data),
      title: {
        text: data.titleText,
        image: TITLE_IMAGE.get(data.titleIcon),
        underlineCSS: UNDERLINE_TYPE.get(data.underlineColor)
      },
      contentCSS: this.#buildContentCSS(data),
      mediaCSS: this.#buildMediaCSS(data),
      media: data.media,
      link: data.buttonUrl,
      description: this.#domSanitizer.bypassSecurityTrustHtml(data.longDescription ?? ''),
      subtitle: { text: data.subtitleText, sizeCSS: SUB_TITLE_SIZE.get(data.subtitleSize) },
      uid: data.uid ?? ''
    };
  }

  #buildMediaCSS(data: FlexibleContentSectionComponent): MediaFit[] {
    return [IMAGE_CONTENT_FIT.get(data.imageFit), data.media ? '' : 'media--none'].filter(Boolean) as MediaFit[];
  }

  #buildSlotCSS(data: FlexibleContentSectionComponent): SlotCSS[] {
    return [
      this.cmsFlexPropsMapper.mapSlotBackgroundColor(data.slotBackgroundColor),
      SLOT_TOP_OFFSET.get(data.offsetTop),
      SLOT_BOTTOM_OFFSET.get(data.offsetBottom)
    ].filter(Boolean) as SlotCSS[];
  }

  #buildContentCSS(data: FlexibleContentSectionComponent): ContentCSS[] {
    return [
      COLUMN_WIDTH.get(data.contentWidth),
      CONTENT_TEXT_POSITION.get(data.contentPosition),
      CONTENT_COLOR.get(data.contentBackgroundColor),
      CONTENT_ALIGNMENT.get(data.contentVerticalAlignment)
    ].filter(Boolean) as ContentCSS[];
  }
}
